<script setup>
defineProps({
  tone: { type: String, default: 'glass' }, /* glass | strong | solid | gold */
  padded: { type: Boolean, default: true },
  grain: { type: Boolean, default: false }
})
</script>

<template>
  <div class="panel" :class="[`panel--${tone}`, { 'panel--padded': padded, 'grain-overlay': grain }]">
    <slot />
  </div>
</template>

<style scoped>
.panel {
  position: relative;
  border-radius: var(--r-md);
  border: 1px solid var(--ash);
  backdrop-filter: blur(8px) saturate(140%);
  -webkit-backdrop-filter: blur(8px) saturate(140%);
  box-shadow: var(--shadow-glass);
  color: var(--ink);
}
/* Thin gold top hairline — signature cinematic accent */
.panel::before {
  content: "";
  position: absolute;
  top: 0; left: 0; right: 0;
  height: 1px;
  background: linear-gradient(90deg, transparent 0%, var(--gold) 35%, var(--gold) 65%, transparent 100%);
  opacity: 0.5;
  pointer-events: none;
}
.panel--glass    { background: var(--bg-glass); }
.panel--strong   { background: var(--bg-glass-strong); }
.panel--solid    { background: var(--bg-deep); backdrop-filter: none; }
.panel--gold {
  background: linear-gradient(180deg, rgba(229, 199, 107, 0.10), rgba(229, 199, 107, 0.02));
  border-color: rgba(229, 199, 107, 0.32);
}
.panel--padded  { padding: var(--sp-6); }
@media (min-width: 720px) {
  .panel--padded { padding: var(--sp-8); }
}
</style>
